<template lang="html">
	<section class="comp-ctn-docs">
		<div class="ctn-docs row">
			<tile-doc :doc="doc" v-for="(doc, key) in docs" v-bind:key="key"/>
			<div class="no-docs" v-if="docs.length === 0">
				Pas de document pour le moment
			</div>
		</div>
  </section>
</template>

<script>
import TileDoc from '@/common/components/tile-doc'
export default {
	components: {
		TileDoc
	},
	data () {
		return {
			docs: []
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ModelsAndTemplates.vue?281fb996